import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import colors from "tailwindcss/colors.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export default function ProcessedCallsByStatus(props) {
  const { completedCalls, failedCalls, pendingCalls } = props;

  const options = {
    responsive: false,
    indexAxis: "y",
    aspectRatio: 1,
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          padding: 24,
          font: {
            size: 12,
          },
        },
        padding: 36,
        onClick: () => {},
      },
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 14,
            lineHeight: 1.5,
          },
        },
        border: {
          color: "gray",
          width: 0,
        },
      },
      x: {
        grid: {
          display: false,
        },
        border: {
          color: colors.gray[400],
          width: 0,
        },
        ticks: {
          font: {
            size: 12,
            lineHeight: 4,
          },
        },
      },
    },
  };

  const data = {
    labels: ["Completed", "Failed"],
    datasets: [
      {
        axis: "x",
        data: [completedCalls, failedCalls],
        label: "Calls",
        backgroundColor: [colors.emerald[300], colors.red[500]],
      },
    ],
  };

  return (
    <Bar
      options={options}
      data={data}
    />
  );
}
